import { courseNameLegacyTagRE } from 'utils'

export default class ProductName extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    block: PropTypes.bool,
  }

  render() {
    const {
      name,
      block,
      className,
    } = this.props
    const classes = cx(className, 'course-title', { block })
    const match = courseNameLegacyTagRE.exec(name)
    if(!match) {
      return <span className={classes}>{name}</span>
    }
    return (
      <span className={classes}>
        {match[1]}
        <small className="text-muted">{match[2]}</small>
      </span>
    )
  }
}
